(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function autoplayDeferredVideos(root) {
      root.querySelectorAll('deferred-media').forEach(function (dm) {
        var playBtn = dm.querySelector('[ref="deferredMediaPlayButton"], .deferred-media__poster-button');
        if (!playBtn) return;

        // Use IntersectionObserver: play with sound when visible, mute when leaving
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = dm.querySelector('video');
            if (entry.isIntersecting) {
              if (!dm.dataset.bearLoaded) {
                // First time visible: click play to load the video
                playBtn.click();
                dm.dataset.bearLoaded = '1';
                // Wait for video to be injected, then unmute
                setTimeout(function () {
                  video = dm.querySelector('video');
                  if (video) {
                    video.muted = false;
                    video.loop = true;
                  }
                }, 400);
              } else if (video) {
                // Returning to slide: unmute
                video.muted = false;
              }
            } else {
              // Leaving slide: mute automatically
              if (video) video.muted = true;
            }
          });
        }, { threshold: 0.5 });

        observer.observe(dm);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        autoplayDeferredVideos(document);
      });
    } else {
      autoplayDeferredVideos(document);
    }

    document.addEventListener('slideshow:change', function (e) {
      if (e.target) autoplayDeferredVideos(e.target);
    });

    var mo = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) autoplayDeferredVideos(node);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-description-tabs"] && !Shopify.designMode) return;
  try {
    class ProductTabs extends HTMLElement {
    constructor() {
      super();
      this.tabs = this.querySelectorAll('[role="tab"]');
      this.panels = this.querySelectorAll('[role="tabpanel"]');
      this.bindEvents();
    }

    bindEvents() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.switchTab(tab));
      });
    }

    switchTab(selectedTab) {
      const target = selectedTab.dataset.tabTarget;

      this.tabs.forEach(tab => {
        tab.classList.remove('product-tabs__tab--active');
        tab.setAttribute('aria-selected', 'false');
      });
      selectedTab.classList.add('product-tabs__tab--active');
      selectedTab.setAttribute('aria-selected', 'true');

      this.panels.forEach(panel => {
        if (panel.dataset.tabPanel === target) {
          panel.classList.add('product-tabs__panel--active');
          panel.hidden = false;
        } else {
          panel.classList.remove('product-tabs__panel--active');
          panel.hidden = true;
        }
      });
    }
  }

  if (!customElements.get('product-tabs')) {
    customElements.define('product-tabs', ProductTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
